import { Skeleton } from '@repo/ui/skeleton';
import { cn } from '@repo/utils/cn';

interface SimpleListSkeletonProps {
  className?: string;
  itemClassName?: string;
  itemsCount?: number;
}

const SimpleListSkeleton = ({ className, itemClassName, itemsCount = 6 }: SimpleListSkeletonProps) => {
  return (
    <div className={cn('flex flex-col items-center sm:items-start', className)}>
      <div className="relative top-2 flex w-full flex-row space-x-2 sm:flex-col sm:space-x-0 rtl:space-x-reverse sm:rtl:space-x-0">
        {Array.from({ length: itemsCount }, (_, i) => (
          <div
            key={i}
            className={cn('mt-1 h-2 w-12', itemClassName)}
          >
            <Skeleton className="h-full w-full rounded-sm" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimpleListSkeleton;
